import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { parseContent } from 'client/data/cms/content';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { CmsModel } from 'client/data/models/cms';
import { GLOSSARY_BREADCRUMBS, GLOSSARY_CONTENT_PATH } from 'site-modules/glossary/constants/glossary';
import { Glossary } from './glossary';

export const pageOptions = {
  name: 'other_glossary_index',
  category: 'other',
  preload: store => {
    const preloader = new ModelPreloader(store);

    preloader.resolve(`content["${GLOSSARY_CONTENT_PATH}.withContent"]`, CmsModel);

    return preloader.load();
  },
  seo: state => {
    const modelState = getModelState(state);
    const content = modelState.get(`content["${GLOSSARY_CONTENT_PATH}.withContent"]`, CmsModel);

    return {
      ...getMeta(parseContent(content)),
      jsonld: [getBreadcrumbSchema(GLOSSARY_BREADCRUMBS)],
    };
  },
  component: Glossary,
};

export default pageDefinition(pageOptions);
